import { useEffect, useState } from 'react';
import Navbar from '../component/Navbar';
import Hero from '../component/Hero';
import Services from '../component/Services';
import AOS from 'aos';
import 'aos/dist/aos.css';
import About from '../component/About';
import WarehouseImpactSection from '../component/WarehouseImpactSection';
import './Secondpage.css';
import Footer from '../component/Footer';
import Contact from '../component/Contact';
import Ourvision from '../component/Ourvision';
import WarehouseOccupancy from '../component/WarehouseOccupancy';
import ReasonForUtilisation from '../component/ReasonForUtilisation';

function Secondpage() {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
      easing: 'ease-out-cubic',
    });
  }, []);

  return (
    <div>
      <Navbar />
      <Hero />
      <Services />
      <About />
      <Ourvision />
      <WarehouseImpactSection />
      <WarehouseOccupancy />
      <ReasonForUtilisation />
      <Contact />
      <Footer />
    </div>
  )
}

export default Secondpage





















